module.exports = __webpack_public_path__ + "static/pointer.2e526db8.png";